/**
 * @param {String} name - the name of the cookie
 * @returns {String} the cookie
 */
function readCookie( name: string ): string {
    const nameEQ = name + '=';
    const ca = document.cookie.split( ';' );

    for ( let i = 0; i < ca.length; i++ ) {
        let c = ca[ i ];

        while ( c.charAt( 0 ) === ' ' ) {
            c = c.substring( 1, c.length );
        }

        if ( c.indexOf( nameEQ ) === 0 ) {
            return c.substring( nameEQ.length, c.length );
        }
    }

    return '';
}

const defaultAttributes: Record<string, string> = {
    'path': '/',
    'SameSite': 'Lax',
    'Secure': '',
};

/**
 * @param {String} name - the name to store the cookie under
 * @param {String} value - the value of the cookie
 * @param {Number} - the number days to last
 */
function createCookie( name: string, value: any, days = 0 ): void {
    const attributes: Record<string, string> = Object.assign( {}, {
        [ name ]: value,
    }, defaultAttributes );

    if ( days > 0 ) {
        const date = new Date();
        date.setTime( date.getTime() + days * 24 * 60 * 60 * 1000 );
        attributes[ 'expires' ] = date.toUTCString();
    }

    const attributesJoined: string[] = [];

    Object.keys( attributes ).forEach( function( attr: string ) {
        if ( attributes[ attr ].length > 0 ) {
            attributesJoined.push( attr + '=' + attributes[ attr ] );
        } else {
            attributesJoined.push( attr );
        }
    } );

    const cookie = attributesJoined.join( ';' );

    document.cookie = cookie;
}

/**
 * @param {String} name - the name of the cookie to remove
 */
function eraseCookie( name: string ): void {
    createCookie( name, '', -1 );
}

function setLastSearchResultPageCookie(): void {
    createCookie( 'lv', document.location.href, 14 );
}

export {
    createCookie,
    readCookie,
    eraseCookie,
    setLastSearchResultPageCookie,
};
